import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        venueOpeningHours: {
            type: Object,
            required: true
        }
    }
});
